export const Mofication_informations = 88;
export const Mofication_informations_CST = 298;
export const Mofication_informations_DEVELOPPEMENT = 305;
